export type BackDropAction =
  | {
      type: "BACK_DROP_OPEN";
    }
  | {
      type: "BACK_DROP_CLOSE";
    };

function openBackDrop(): BackDropAction {
  return { type: "BACK_DROP_OPEN" };
}

function closeBackDrop(): BackDropAction {
  return { type: "BACK_DROP_CLOSE" };
}

export const BackDropActions = {
  openBackDrop,
  closeBackDrop,
};
